export default "__VITE_ASSET__BbwPD$yx__"